import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardHeader, CardTitle, CardContent } from '../components';
import { Plus, Search, CheckCircle2, AlertCircle, Clock } from 'lucide-react';

export const DashboardPage: React.FC = () => {
  // Mock data - será substituído por dados reais do banco
  const metrics = {
    total: 0,
    inProgress: 0,
    completed: 0,
    errors: 0,
  };

  const recentInvestigations: any[] = [];

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white mb-2">Dashboard</h1>
          <p className="text-gray-400">Visão geral de suas investigações</p>
        </div>
        <Link to="/investigacoes/nova">
          <Button variant="primary" size="lg" className="flex items-center gap-2">
            <Plus className="w-5 h-5" />
            Nova Investigação
          </Button>
        </Link>
      </div>

      {/* Métricas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card>
          <CardContent className="space-y-2">
            <p className="text-gray-400 text-sm">Total de Investigações</p>
            <p className="text-3xl font-bold text-white">{metrics.total}</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="space-y-2">
            <div className="flex items-center justify-between">
              <p className="text-gray-400 text-sm">Em Andamento</p>
              <Clock className="w-4 h-4 text-amber-500" />
            </div>
            <p className="text-3xl font-bold text-amber-500">{metrics.inProgress}</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="space-y-2">
            <div className="flex items-center justify-between">
              <p className="text-gray-400 text-sm">Concluídas</p>
              <CheckCircle2 className="w-4 h-4 text-green-500" />
            </div>
            <p className="text-3xl font-bold text-green-500">{metrics.completed}</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="space-y-2">
            <div className="flex items-center justify-between">
              <p className="text-gray-400 text-sm">Erros</p>
              <AlertCircle className="w-4 h-4 text-red-500" />
            </div>
            <p className="text-3xl font-bold text-red-500">{metrics.errors}</p>
          </CardContent>
        </Card>
      </div>

      {/* Investigações Recentes ou Estado Vazio */}
      <Card>
        <CardHeader>
          <CardTitle>Investigações Recentes</CardTitle>
        </CardHeader>
        <CardContent>
          {recentInvestigations.length === 0 ? (
            <div className="text-center py-12">
              <Search className="w-12 h-12 text-gray-600 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-white mb-2">Nenhuma investigação ainda</h3>
              <p className="text-gray-400 mb-6">
                Comece a sua primeira pesquisa para agregrar informações de fontes autorizadas.
              </p>
              <Link to="/investigacoes/nova">
                <Button variant="primary">Nova Investigação</Button>
              </Link>
            </div>
          ) : (
            <div className="space-y-4">
              {recentInvestigations.map((inv) => (
                <div
                  key={inv.id}
                  className="border border-gray-800 rounded p-4 hover:border-gray-700 transition-colors"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <h4 className="font-medium text-white">{inv.title}</h4>
                      <p className="text-sm text-gray-400 mt-1">{inv.purpose}</p>
                    </div>
                    <span
                      className={`px-3 py-1 rounded text-xs font-medium ${
                        inv.status === 'concluida'
                          ? 'bg-green-900 text-green-200'
                          : inv.status === 'em_progresso'
                          ? 'bg-amber-900 text-amber-200'
                          : 'bg-gray-800 text-gray-200'
                      }`}
                    >
                      {inv.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
